import { Grid, IconButton, Tooltip } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import { userPreferencesTypes } from "components/UserPreferences/userPreferencesConsts";
import { useUpdateUserPreferenceMutation } from "components/UserPreferences/userPreferencesSlice";
import { debounce } from "lodash";
import FilterService from "services/filterService";
import { selectedFilterStyle } from "./style";
import { useSelector } from "react-redux";
import { selectIsClient } from "features/user/userSlice";

export const SelectedFilters = ({
  filters,
  filterConfig,
  onClearFilter,
  className,
  selectedViewId,
  tableId
}) => {
  const classes = selectedFilterStyle();

  let isClient = useSelector(selectIsClient);

  const filtersDisplay = FilterService.getFilterDisplay(filters, filterConfig, isClient);
  const [updatePref, { isLoading: isSaving }] = useUpdateUserPreferenceMutation();

  const onClear = (filterKey) => {
    const newFilters = { ...filters, [filterKey]: { value: null } }
    onClearFilter(filterKey);
    saveViewFilters(newFilters);
  }

  //TODO this needs refactoring to share the saving with the TableFilters component
  const saveViewFilters = debounce((listToSave) => {
    let filtersList = Object.entries(listToSave).map(([key, value]) => ({ key: key, value: JSON.stringify(value) }));
    const prefToSave = { filters: filtersList };
    let res = updatePref({ componentId: tableId, type: userPreferencesTypes.FILTERS, ...prefToSave, viewId: selectedViewId })
  }, 500)

  return (
    <>
      {!!filtersDisplay?.length && (
        <div className={className}>
          <div className={classes.title}>Selected Filters</div>

          <Grid container className={classes.selectedFilters} spacing={2}>
            {filtersDisplay.map((f, index) => {
              const values = String(f.value || '').split(',');
              const visibleValues = values.slice(0, 2).join(', ');
              const remaining = values.length - 2;

              const labelContent = (
                <>
                  {f.label}:
                  <span className={classes.text}> {visibleValues} </span>
                  {remaining > 0 && (
                    <span className={classes.moreText}> and {remaining} more.</span>
                  )}
                </>
              );

              return (
                <Grid key={index} item>
                  <Grid
                    container
                    className={classes.item}
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={1}
                  >
                    <Grid item xs>
                      {f.tooltipContent !== undefined ? (
                        <Tooltip title={f.tooltipContent}>
                          <span>{labelContent}</span>
                        </Tooltip>
                      ) : (
                        labelContent
                      )}
                    </Grid>
                    <Grid item>
                      <IconButton size="small" onClick={() => onClear(f.key)}>
                        <CloseIcon className={classes.clear} />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
        </div>
      )}
    </>

  )
}